import PropTypes from 'prop-types';
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import JoinInfoPage from './JoinInfoPage.jsx';

class JoinInfoModal extends React.Component {
  static propTypes = {
    onDone: PropTypes.func.isRequired,
    code: PropTypes.string.isRequired,
  };

  onDone = () => {
    this.props.onRequestHide();
    this.props.onDone();
  };

  render() {
    return (
      <Dialog {...this.props} size="small">
        <JoinInfoPage code={this.props.code} onDone={this.onDone} />
      </Dialog>
    );
  }
}

export default JoinInfoModal;
